import { APP_NAME } from 'services/constants';
import { LocalStorageCache } from 'services/cache';

export default new LocalStorageCache(`${APP_NAME}/token`);
